import React, {useState} from 'react';
import css from './Header.module.scss'
import logo from '../../../images/main-logo.svg'
import notification from '../../../images/notification.svg'
import burger from '../../../images/burger.svg'
import avatar from '../../../images/user-placeholder.png'
import {NavLink} from "react-router-dom";
import Notifications from "../Notifications/Notifications";
import {connect} from "react-redux";

const Header = ({openMenu, isDark, profile, token, notifications}) => {
  const [isNotificationModal, setIsNotificationModal] = useState(false)
  return (
    <div className={`${css.headerWrapper} ${isDark && `${css.headerWrapper__dark}`}`}>
      <div className={css.header}>
        <NavLink to={token ? '/logbook' : '/logbook/auth'}>
          <img src={logo} alt=""/>
        </NavLink>
        {token && <div className={css.header__items}>
          <button onClick={() => setIsNotificationModal(true)} className={css.notificationWrapper}>
            {notifications.filter(n => n.is_delivered === false).length > 0 && <div className={css.notificationCount}>
              {notifications.filter(n => n.is_delivered === false).length}
            </div>}
            <img src={notification} alt=""/>
          </button>
          {isNotificationModal && <>
            <div onClick={() => setIsNotificationModal(false)} className="transparent-overlay"/>
            <Notifications closeModal={() => setIsNotificationModal(false)}/>
          </>}
          <NavLink to={'/logbook/profile/licenses'} className={css.avatarWrapper}>
            <img src={profile?.image_link ? `data:image/png;base64,${profile?.image_link}` : avatar} alt="" className={css.avatar}/>
          </NavLink>
          <button onClick={openMenu} className={css.burger}>
            <img src={burger} alt=""/>
          </button>
        </div>}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  profile: state.userReducer.profile,
  token: state.authReducer.token,
  notifications: state.notificationsReducer.notifications
})

export default connect(mapStateToProps, {})(React.memo(Header));
